// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1DwB7","additionalInfo":"AgreementModal_additionalInfo__3fJjd"};